import * as React from 'react'
import { mergeRight } from 'ramda'
import { Container } from '../Container'
import { LandingPageButton } from '../LandingPageButton'

type Props = {
  title: string
  subheading: string
  formalMakeName: string
}

export const WarningSignsSoundsSection: React.FC<Props> = ({ title, subheading, formalMakeName }) => (
  <section>
    <Container>
      <h2 style={{ fontSize: '24px', fontWeight: 900 }}>{title}</h2>
      <p>{subheading}</p>
      {/*language=SCSS*/}
      <style jsx>{`
        p {
          color: #f04e23;
          font-size: 50px;
        }
      `}</style>
      <Warnings formalMakeName={formalMakeName} />
    </Container>
  </section>
)

export const Warnings: React.FC<{ formalMakeName: string }> = ({ formalMakeName }) => (
  <div className="grid md:grid-cols-3 gap-2">
    <Warning
      warning={`Grinding, Screeching, Squealing, Rubbing, and Other High-Pitched Noises`}
      description={`High-pitched noises during the braking process likely means you’re dealing with worn out brake pads and shoes. Continuing to drive with worn out pads and shoes can cause further damage to your vehicle if left unattended, so make sure to schedule a brake inspection ASAP.`}
    />
    <Warning
      warning={`Vibration or Pulsing`}
      description={`If you feel vibrations or pulsing in the brake pedal or steering wheel during the process of braking, you’re probably dealing with rotor issues. Warped or damaged rotors can lead to a costly repair bill, so get your vehicle checked as soon as you start feeling the sensation.`}
    />
    <Warning
      warning={`Excessive Brake Pedal Travel`}
      description={`If you feel like your pedal travels further than it should when pushing on the brakes, you’re likely feeling the beginning of brake pad issues. This is the ideal time to get your brakes inspected and repaired, as you’re less likely to have extensive damage.`}
    />
    <Warning
      warning={`Grinding, Screeching, Squealing, Rubbing, and Other High-Pitched Noises`}
      description={`High-pitched noises during the braking process likely means you’re dealing with worn out brake pads and shoes. Continuing to drive with worn out pads and shoes can cause further damage to your vehicle if left unattended, so make sure to schedule a brake inspection ASAP.`}
    />
    <Warning
      warning={`Vibration or Pulsing`}
      description={`If you feel vibrations or pulsing in the brake pedal or steering wheel during the process of braking, you’re probably dealing with rotor issues. Warped or damaged rotors can lead to a costly repair bill, so get your vehicle checked as soon as you start feeling the sensation.`}
    />
    <Warning
      warning={`Schedule A Free Brake Inspection & Estimate For Your ${formalMakeName}`}
      showButton={true}
      description={`If you are experiencing any problematic symptoms, schedule a free inspection and estimate from our Dallas brake techs.`}
      buttonText={`Free ${formalMakeName} Brake Service Estimate`}
    />
  </div>
)

export const Warning: React.FC<{
  warning: string
  description: string
  buttonText?: string
  showButton?: boolean
}> = ({ warning, description, showButton, buttonText }) => {
  const warningStyles = {
    padding: '20px 20px',
  }
  const orangeWarningStyles = {
    border: '1px solid #ead1ca',
    background: '#ffeee7',
  }
  const styles = showButton ? mergeRight(warningStyles, orangeWarningStyles) : warningStyles
  return (
    <div style={styles}>
      <h3
        style={{
          fontSize: '18px',
          fontWeight: 600,
          lineHeight: '1.33',
          color: '#1a1919',
        }}
      >
        <strong>{warning}</strong>
      </h3>
      <p style={{ color: '#818b92' }}>{description}</p>
      {showButton && (
        <div className={'text-center'}>
          <LandingPageButton buttonText={buttonText!} />
        </div>
      )}
    </div>
  )
}
